<template>
  <v-app class="pa-2" v-show="!progress">
    <!-- ふきだし -->
    <v-container>
      <v-row>
        <v-col>
          <Bubble v-show="bubbleContent" :content="bubbleContent" />
        </v-col>
      </v-row>
    </v-container>

    <!-- 注文履歴 -->
    <v-container class="pt-0 pb-0">
      <v-row justify="center" v-for="(order, i) in orders" :key="i">
        <v-col>
          <v-row align="center">
            <v-col class="pt-0 pb-0" align="left">
              <span class="text-body-1">{{
                order.createdAt | moment("YYYY/MM/DD HH:mm")
              }}</span>
            </v-col>
            <!-- 注文状態 -->
            <v-col
              class="pt-0 pb-0"
              align="right"
              v-show="isShowOrderStatusText(order)"
            >
              <span :class="getOrderStatusTextClass(order)">{{
                getOrderStatusText(order)
              }}</span>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            align="center"
            v-for="(menu, i) in order.menus"
            :key="i"
          >
            <v-col cols="9" class="pl-2"
              ><span class="text-body-2">{{ menu.name }}</span></v-col
            >
            <!-- <v-col cols="3" align="right"
                  ><span class="text-body-2"
                    >￥{{ menu.amount | addComma }}</span
                  ></v-col
                > -->
          </v-row>
          <v-row align="center">
            <v-col class="pt-0 pb-0" align="right">
              <span class="text-h5">￥{{ order.amount | addComma }}</span>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="pt-0" align="right">
              <span class="text-caption">( 税込 )</span>
            </v-col>
          </v-row>
          <v-row align="center">
            <!-- 注文番号 -->
            <v-col cols="7" class="pt-0 pb-0">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <span class="text-caption">注文番号</span>
                <span class="text-h5 ml-2">{{ order.orderNo }}</span>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <span class="text-caption">受取時間</span>
                <span class="text-h6 ml-2">{{
                  order.visitTime | moment("HH:mm")
                }}</span>
              </div>
            </v-col>
            <v-col class="pl-4" align="right">
              <!-- <v-chip
                v-if="order.wayOfOrder == 0"
                class="text-overline"
                color="brown lighten-1"
                text-color="white"
              >
                <v-icon small> mdi-cellphone </v-icon>
                予約
              </v-chip>
              <v-chip
                v-else-if="order.wayOfOrder == 1"
                class="text-overline"
                color="brown lighten-1"
                text-color="white"
              >
                <v-icon small> mdi-store </v-icon>
                店内
              </v-chip> -->
              <!-- 決済方法(先払い/あと払い) -->
              <!-- <v-chip
                v-if="order.wayOfPay == 0"
                class="ml-2 text-overline"
                color="brown lighten-1"
                text-color="white"
              >
                先払い
              </v-chip> -->
              <v-chip
                v-if="order.wayOfPay == 1"
                class="ml-2 text-overline"
                color="brown lighten-1"
                text-color="white"
              >
                あと払い
              </v-chip>
              <!-- 決済種類(LINEPay/PayPay/クレカ) -->
              <v-chip
                v-if="order.payType == 0"
                class="ml-2 text-overline green lighten-1"
                text-color="white"
              >
                LINEPay
              </v-chip>
              <v-chip
                v-if="order.payType == 1"
                class="ml-2 text-overline red lighten-1"
                text-color="white"
              >
                PayPay
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="center">
              <v-btn
                large
                tile
                text
                outlined
                :to="{ name: 'OrderHistory', params: { id: order.orderId } }"
                style="width: 100%"
                >くわしく見る</v-btn
              >
            </v-col>
          </v-row>
          <v-divider class="mt-4" v-if="isShowDivider(i)" />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { liffReady } from "../util/liff_util";
import Bubble from "./parts/Bubble";
import {
  ORDER_STATUS_TEXT_TYPE,
  getOrderStatusTextType,
} from "../constants/order_constants";
import { MSG_TYPE } from "../components/error/errorConstants";

export default {
  components: {
    Bubble,
  },
  data: () => ({
    bubbleContent: "",
    orders: [], // 表示用
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "注文履歴";
    this.$store.state.cart = true;
  },
  computed: {
    ...mapGetters(["progress", "historyOrdersViewData"]),
  },
  watch: {
    historyOrdersViewData: function () {
      if (!this.historyOrdersViewData) {
        return;
      }
      this.bindData();
    },
  },
  async mounted() {
    this.showProgress();
    await liffReady(); // LIFF 初期化待機

    try {
      await this.fetchData();
    } catch (error) {
      console.log(error);
      const msgType = MSG_TYPE.LOAD;
      this.$router.push({ name: "Error", query: { msgType: msgType } });
    } finally {
      this.hideProgress();
    }
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress", "fetchHistoryListData"]),
    fetchData: async function () {
      return this.fetchHistoryListData();
    },
    bindData: function () {
      // 注文履歴 一覧
      const orders = this.historyOrdersViewData.historyOrders;
      // console.log("orders", orders);
      this.orders = orders;

      // ふきだし
      let content =
        "いつもご利用ありがとうございます。\n以前のご注文はこちらです。";
      if (orders.length == 0) {
        content = "注文履歴はありません";
      }
      this.bubbleContent = `${content}`;
    },
    isShowOrderStatusText: function (order) {
      const type = getOrderStatusTextType(order);
      return type != ORDER_STATUS_TEXT_TYPE.NOTHING;
    },
    getOrderStatusTextClass: function (order) {
      const type = getOrderStatusTextType(order);
      if (type == ORDER_STATUS_TEXT_TYPE.IN_CONFIRM) {
        return "text-body-2 blue--text";
      } else if (type == ORDER_STATUS_TEXT_TYPE.CANCELED) {
        return "text-body-2 red--text";
      } else {
        return "";
      }
    },
    getOrderStatusText: function (order) {
      const type = getOrderStatusTextType(order);
      if (type == ORDER_STATUS_TEXT_TYPE.IN_CONFIRM) {
        return "注文確認中";
      } else if (type == ORDER_STATUS_TEXT_TYPE.CANCELED) {
        return "注文キャンセル";
      } else {
        return "";
      }
    },
    showDetail: function () {
      //TODO くわしく見る
    },
    isShowDivider: function (index) {
      // 現在の表示要素が最終要素以外の場合、true
      return index + 1 != this.orders.length;
    },
  },
};
</script>
